var React = require('react');

function Card (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 6a3.02 3.02 0 0 0-3 3v14a3.02 3.02 0 0 0 3 3h22a3.02 3.02 0 0 0 3-3V9a3.02 3.02 0 0 0-3-3zm0 2h22a.98.98 0 0 1 1 1v2H5v2h23v10a.98.98 0 0 1-1 1H5a.98.98 0 0 1-1-1V9a.98.98 0 0 1 1-1z"}));
}

Card.defaultProps = {"viewBox":"0 0 32 32","xmlnsV":"https://vecta.io/nano"};

module.exports = Card;

Card.default = Card;
